export default __webpack_public_path__ + "static/media/SISTEMA_DI_SEGNALAZIONE_WHISTLEBLOWING.444098bb.pdf";